/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import * as React from "react";
import { graphql, Link } from 'gatsby';
import PostLink from '../components/post-link';
import Seo from '../components/seo';

const PostList = ({ data, pageContext: { pages, currentPage } }) => {
  return (
    <React.Fragment>
      <Seo title="Home page" description="Test" />
      <ul sx={{
        textDecoration: "none",
        listStyle: "none",
        margin: 0,
        padding: 0
      }}>
        {
          data.allMdx.nodes.map((node) => (
            <li key={node.id} sx={{ textDecoration: "none", marginBottom: 30 }}>
              <article >
                <PostLink
                  link={node.fields.postPath}
                  title={node.frontmatter.title}
                  date={node.frontmatter.date}
                  category={node.frontmatter.category}
                />
              </article>
            </li>
          ))
        }
      </ul>
      <Flex sx={{ alignItems: "center", width: "100%" }}>
        {currentPage <= 0 ? <span sx={{ marginRight: 1}}>« Prev</span> : <Link to={currentPage - 1 === 0 ? `/` : `/page-${currentPage - 1}`} sx={{ marginRight: 1}}>« Prev</Link>}
        <Flex sx={{ overflowX: "auto" }}>
          {pages.map(page => (
            currentPage === page ? <em key={page} sx={{ textDecoration: "none", marginRight: 1 }}>{page}</em> : <Link key={page} to={page <= 0 ? `/` : `/page-${page}`} sx={{ marginRight: 1 }}>{page}</Link>
          ))}
        </Flex>
        {currentPage >= (pages.length - 1) ? <span sx={{ marginRight: 1}}>Next »</span> : <Link to={currentPage + 1 === 0 ? `/` : `/page-${currentPage + 1}`} sx={{ marginRight: 1}}>Next »</Link>}
      </Flex>
    </React.Fragment>
  )
}

export default PostList;

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    allMdx(
      sort: {fields: frontmatter___date, order: DESC}
      filter: {fileAbsolutePath: {regex: "/posts/"}}
      limit: $limit
      skip: $skip
    ) {
      nodes {
        fields {
          postPath
        }
        frontmatter {
          title
          date(formatString: "MMMM D, YYYY")
          category
        }
        id
        body
        slug
        parent {
          ... on File {
            modifiedTime(formatString: "MMMM D, YYYY")
          }
        }
      }
    }
  }
`;
